import { ArcElement, Chart as ChartJS, Legend, Tooltip } from 'chart.js';
import { format, parse } from 'date-fns';
import queryString from 'query-string';
import { useEffect, useState } from 'react';
import { Doughnut } from 'react-chartjs-2';
import { connect } from 'react-redux';
import {
  changeCitationRequestDisplay,
  changeCitationRequestPopupWindow,
  getCitationRequestCurrentMonthAndYear,
  getCitationRequests,
  selectCitationRequest,
  selectTargetDayForCitationRequests,
} from '../../actions/citationRequestAction';
import styles from '../../styles/calendar/Calendar.module.scss';
import { generateSafeDateFromMonthYear } from '../../utils/helper';
import {
  Calendar,
  CalendarCells,
  CalendarDays,
  CalendarHeader,
  CalendarProvider,
  doughnutOptions,
  getChartData,
} from '../calendar';
import CitationFilters from './CitationFilters';

ChartJS.register(ArcElement, Tooltip, Legend);

const CitationRequestsCalendar = ({
  selectedDate,
  setSelectedDate,
  statuses,
  setStatuses,
  storageKey,
  ...props
}) => {
  const [currentMonth, setCurrentMonth] = useState(() => {
    return localStorage.getItem(storageKey) !== null
      ? localStorage.getItem(storageKey)
      : format(new Date(), 'MMM yyyy');
  });

  const handleOnDateClick = day => {
    const idx = format(day, 'd');
    const filteredCitationRequests =
      props.citationRequests[idx]?.filter(ele => {
        const status = ele.status?.toLowerCase();
        return statuses[status];
      }) || [];

    if (filteredCitationRequests.length > 0) {
      const currentDate = parse(currentMonth, 'MMM yyyy', new Date());
      currentDate.setDate(idx);
      props.selectTargetDayForCitationRequests(filteredCitationRequests);
    }
    if (filteredCitationRequests.length === 1) {
      props.selectCitationRequest(filteredCitationRequests[0]);
      props.changeCitationRequestDisplay('detail');
    }
    if (filteredCitationRequests.length > 1) {
      props.changeCitationRequestDisplay('list');
    }
  };
  const STATUS_KEYS = Object.keys(statuses);

  const renderCellContent = (citationRequestsForTheDay, day) => {
    const currentDate = parse(currentMonth, 'MMM yyyy', new Date());
    currentDate.setDate(day);

    const chartData = {};
    let totalCitationRequests = 0;

    STATUS_KEYS.forEach(statusKey => {
      if (statuses[statusKey]) {
        chartData[statusKey] = citationRequestsForTheDay.filter(
          req => req.status.toLowerCase() === statusKey
        );
        totalCitationRequests += chartData[statusKey].length;
      } else {
        chartData[statusKey] = [];
      }
    });

    const doughnutData = getChartData(chartData, 'Citation Requests');

    return (
      <div
        className={styles['request-calendar-day-container']}
        style={{ padding: '3px' }}>
        <div className={styles['num-container']}>
          <p
            className={styles['total-requests-num']}
            style={{ marginBottom: '0' }}>
            {totalCitationRequests}
          </p>
          <p style={{ fontSize: '0.8rem', marginBottom: '0' }}>
            {totalCitationRequests === 1 ? 'Request' : 'Requests'}
          </p>
        </div>
        <Doughnut
          width={110}
          height={110}
          data={doughnutData}
          options={doughnutOptions}
        />
      </div>
    );
  };
  useEffect(() => {
    let currentDate;
    if (localStorage.getItem(storageKey) !== null) {
      currentDate = generateSafeDateFromMonthYear(
        localStorage.getItem(storageKey)
      );
    } else {
      currentDate = new Date();
    }

    props.getCitationRequestCurrentMonthAndYear(
      currentDate.getMonth() + 1,
      currentDate.getFullYear()
    );
    props.getCitationRequests(props.nextAPI, props.params);
    const trackerId = queryString.parse(window.location.search).id;
    if (trackerId) {
      props.openNotificationDetailReport(trackerId);
      props.changeReportTrackingDisplay('detail');
    }
  }, []);
  return (
    <CalendarProvider
      currentMonth={currentMonth}
      setCurrentMonth={setCurrentMonth}
      storageKey={storageKey}>
      <Calendar>
        <CalendarHeader
          isLoading={props.isLoading}
          getRequestCurrentMonthAndYear={
            props.getCitationRequestCurrentMonthAndYear
          }>
          <CitationFilters
            statuses={statuses}
            setStatuses={setStatuses}
            changeCitationRequestDisplay={props.changeCitationRequestDisplay}
            changeCitationRequestPopupWindow={
              props.changeCitationRequestPopupWindow
            }
          />
        </CalendarHeader>
        <CalendarDays />
        <CalendarCells
          selectedDate={selectedDate}
          setSelectedDate={setSelectedDate}
          calendarData={props.isLoading ? [] : props.citationRequests}
          onDateClick={handleOnDateClick}
          renderCellContent={renderCellContent}
        />
      </Calendar>
    </CalendarProvider>
  );
};

const mapStateToProps = state => ({
  isLoading: state.citationRequestReducer.isCalendarLoading,
  citationRequests: state.citationRequestReducer.allCitationRequestsForDays,
  userProfile: state.userReducer.userProfile,
  nextAPI: state.citationRequestReducer.nextAPI,
  params: {
    sort_direction: state.citationRequestReducer.citationRequestSortDirection,
    sort_by: state.citationRequestReducer.citationRequestSortedBy,
    filter: state.citationRequestReducer.citationRequestFilter,
  },
});

const mapDispatchToProps = {
  selectCitationRequest,
  selectTargetDayForCitationRequests,
  getCitationRequestCurrentMonthAndYear,
  changeCitationRequestDisplay,
  changeCitationRequestPopupWindow,
  getCitationRequests,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CitationRequestsCalendar);
